import React from 'react'
import CardList from '../../components/cards/cards-list'

export default function CardsAllPage(): React.ReactElement {
   return <CardList />
}
